import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';

interface IWaitingRoomToastPresenter {
  call: Call;
  isSidebarVisible: boolean;
  waitingRoomMembersCount: number;
  isWaitingRoomEnabled: boolean;
  showMembers(): void;
}

export const useWaitingRoomToastPresenter = (): IWaitingRoomToastPresenter => {
  const context = useCallContext();

  const presenter = useLocalObservable<IWaitingRoomToastPresenter>(() => ({
    get call(): Call {
      return context.call;
    },

    get isSidebarVisible(): boolean {
      return presenter.call.viewState.isMembersShown;
    },

    get waitingRoomMembersCount(): number {
      return presenter.call.waitingRoom.requestedMembersArray.length;
    },

    get isWaitingRoomEnabled(): boolean {
      return presenter.call.waitingRoom.enabled;
    },

    showMembers(): void {
      presenter.call.viewState.showMembers();
    },
  }));

  return presenter;
};
